import { RootState } from "src/store";

export * from "./batchActions";
export * from "./details";

const selectSearchQuery = (state: RootState): string => state.devices.search?.query ?? "";
const selectPaneTab = (state: RootState) => state.devices.pane.tab;
const selectPaneEditEnabled = (state: RootState) => state.devices.pane.editEnabled;
const selectPaneStatus = (state: RootState) => state.devices.pane.status;
const selectDevicePageExternalFilterUpdate = (state: RootState) => state.devices.devicePageExternalFilterUpdate ?? 0;

export { selectDevicePageExternalFilterUpdate, selectPaneEditEnabled, selectPaneStatus, selectPaneTab, selectSearchQuery };
